<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="单据编号">
              <a-input placeholder="请输入单据编号" v-model="queryParam.billNo"></a-input>
            </a-form-item>
          </a-col>
          <a-col :xl="10" :lg="11" :md="12" :sm="24">
            <a-form-item label="单据日期">
              <j-date placeholder="请选择开始日期" class="query-group-cust" v-model="queryParam.billDate_begin"></j-date>
              <span class="query-group-split-cust"></span>
              <j-date placeholder="请选择结束日期" class="query-group-cust" v-model="queryParam.billDate_end"></j-date>
            </a-form-item>
          </a-col>
          <template v-if="toggleSearchStatus">
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item label="所属门店">
                <j-dict-select-tag placeholder="请选择所属门店" v-model="queryParam.storeId" dictCode="sales_physical_store,phystore_name,id"/>
              </a-form-item>
            </a-col>
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item label="经办人员">
                <j-select-user-by-dep placeholder="请选择经办人员" v-model="queryParam.handlerId"/>
              </a-form-item>
            </a-col>
            <a-col :xl="10" :lg="11" :md="12" :sm="24">
              <a-form-item label="单据状态">
                <j-dict-select-tag type="list" v-model="queryParam.billStatus"
                                   dictCode="x_bill_proc_status" placeholder="请选择单据状态"/>
              </a-form-item>
            </a-col>
          </template>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">查询</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">重置</a-button>
              <a @click="handleToggleSearch" style="margin-left: 8px">
                {{ toggleSearchStatus ? '收起' : '展开' }}
                <a-icon :type="toggleSearchStatus ? 'up' : 'down'"/>
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="myHandleAdd"  type="primary" icon="plus">新增</a-button>
      <a-button type="primary" icon="download" @click="handleExportXls('要货申请流程表单')">导出</a-button>
      <a-upload name="file" :showUploadList="false" :multiple="false" :headers="tokenHeader" :action="importExcelUrl" @change="handleImportExcel">
        <a-button type="primary" icon="import">导入</a-button>
      </a-upload>
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item disabled="!isBatchDelEnabled" key="1" @click="batchDel"><a-icon type="delete"/>删除</a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px"> 批量操作 <a-icon type="down" /></a-button>
      </a-dropdown>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i>已选择<a style="font-weight: 600">{{ selectedRowKeys.length }}</a>项
        <a style="margin-left: 12px" @click="onClearSelected">清空</a>
      </div>

      <a-table
        ref="table"
        size="middle"
        bordered
        rowKey="id"
        class="j-table-force-nowrap"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        @change="handleTableChange">

        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template slot="imgSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">无图片</span>
          <img v-else :src="getImgView(text)" height="25px" alt="" style="max-width:80px;font-size: 12px;font-style: italic;"/>
        </template>
        <template slot="fileSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">无文件</span>
          <a-button
            v-else
            :ghost="true"
            type="primary"
            icon="download"
            size="small"
            @click="uploadFile(text)">
            下载
          </a-button>
        </template>
        <a slot="billNo" @click="myHandleDetail(record)" slot-scope="text, record">{{text}}</a>

        <span slot="action" slot-scope="text, record">
          <a :disabled="!record.actionsEnabled.edit" @click="myHandleEdit(record)">编辑</a>
          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link">更多 <a-icon type="down" /></a>
            <a-menu slot="overlay">
              <a-menu-item :disabled="!record.actionsEnabled.delete" key="1" >
                <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record.id)">删除</a-popconfirm>
              </a-menu-item>
              <a-menu-item v-if="!record.actionsEnabled.approve"  :disabled=true key="2" @click="handleApprove(record)">审核</a-menu-item>
              <a-menu-item v-else-if="record.actionsEnabled.approve && hasPerm"  :disabled=false   key="2" @click="handleApprove(record)">审核</a-menu-item>
              <a-menu-item v-else :disabled=true  key="2" @click="handleApprove(record)">审核</a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>

      </a-table>
    </div>

    <stkRequestIn-modal ref="modalForm" @ok="modalFormOk"></stkRequestIn-modal>
  </a-card>
</template>

<script>

  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import StkRequestInModal from './modules/StkRequestInModal'
  import JDictSelectTag from '@/components/dict/JDictSelectTag.vue'
  import JDate from '@/components/jeecg/JDate.vue'
  import {filterMultiDictText} from '@/components/dict/JDictSelectUtil'
  import JSelectUserByDep from '@/components/jeecgbiz/JSelectUserByDep'
  import '@/assets/less/TableExpand.less'
  import { disabledAuthFilter } from "@/utils/authFilter"


  export default {
    name: "StkRequestInList",
    mixins:[JeecgListMixin],
    components: {
      JDictSelectTag,
      JDate,
      JSelectUserByDep,
      StkRequestInModal
    },
    created(){
      let isDisabled = disabledAuthFilter("stkreq:in:audit")
      this.hasPerm = !isDisabled
    },
    data () {
      return {
        description: '要货申请流程表单管理页面',
        hasPerm:false,
        // 表头
        columns: [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender:function (t,r,index) {
              return parseInt(index)+1;
            }
          },
          {
            title:'单据编号',
            align:"center",
            width: 180,
            dataIndex: 'billNo',
            scopedSlots: { customRender: 'billNo' }
          },
          {
            title:'单据日期',
            align:"center",
            dataIndex: 'billDate',
            customRender:function (text) {
              return !text?"":(text.length>10?text.substr(0,10):text)
            }
          },
          {
            title:'所属门店',
            align:"center",
            dataIndex: 'storeId_dictText'
          },
          {
            title:'经办人员',
            align:"center",
            dataIndex: 'handlerId_dictText'
          },
          {
            title:'单据状态',
            align:"center",
            dataIndex: 'billStatus_dictText'
          },
          {
            title:'审核人',
            align:"center",
            dataIndex: 'approverId_dictText'
          },
          {
            title:'是否通过',
            align:"center",
            dataIndex: 'isApproved_dictText'
          },
          {
            title:'生效时间',
            align:"center",
            dataIndex: 'effectiveTime',
            customRender:function (text) {
              return !text?"":(text.length>10?text.substr(0,10):text)
            }
          },
          // {
          //   title:'是否作废',
          //   align:"center",
          //   dataIndex: 'isVoided_dictText'
          // },
          // {
          //   title:'是否关闭',
          //   align:"center",
          //   dataIndex: 'isClosed_dictText'
          // },
          {
            title: '操作',
            dataIndex: 'action',
            align:"center",
            scopedSlots: { customRender: 'action' }
          }
        ],
        url: {
          list: "/stock/stkRequestIn/list",
          delete: "/stock/stkRequestIn/delete",
          deleteBatch: "/stock/stkRequestIn/deleteBatch",
          exportXlsUrl: "/stock/stkRequestIn/exportXls",
          importExcelUrl: "stock/stkRequestIn/importExcel",
        },
        dictOptions:{},
      }
    },
    computed: {
      importExcelUrl: function(){
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      },
      isBatchDelEnabled: function () {
        for (let i = 0; i < this.selectedRowKeys.length; i++) {
          if (!this.selectionRows[i].actionsEnabled.delete) {
            return false;
          }
        }
        return true;
      }
    },
    methods: {
      initDictConfig() {
      },
      myHandleAdd() {
        this.$refs.modalForm.action = "add";
        this.handleAdd();
      },
      myHandleEdit(record) {
        record.billStatus = '12';
        this.$refs.modalForm.action = "edit";
        this.handleEdit(record);
      },
      myHandleDetail(record) {
        this.$refs.modalForm.action = "detail";
        this.handleDetail(record);
      },
      handleApprove(record) {
        debugger
        this.$refs.modalForm.action = "approve";
        this.$refs.modalForm.edit(record);
        this.$refs.modalForm.title = "审核";
      },
    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';
</style>